export default "__VITE_ASSET__15c424ee__"